import CityPageTemplate from "../city-template/CityPageTemplate";
import { farmingtonHillsConfig } from "./data";

export default function FarmingtonHillsPage() {
  return <CityPageTemplate config={farmingtonHillsConfig} />;
}